import React from "react";

import { AccountEmail, AccountPassword } from "EmployerApplication/Components/FinalFormQuestions";
import createDecorator from "final-form-focus";
import isIntuit from "Intuit/isIntuit";
import { Form } from "react-final-form";
import { useHistory } from "react-router-dom";
import AnalyticsTracking from "Utils/AnalyticsTracking";
import BasicLoading from "ZeroRuby/BasicLoading";

import { useCreateFromDarkAccountMutation, useGetCurrentCompanyApplicationQuery } from "../api";
import { companyInformationURL, addEmployeesURL } from "../urls";
import AgentHeader from "Common/Agent/AgentHeader";
import { rtkQueryReponseToSubmissionError } from "Common/forms";
import { Row } from "Common/Grid";
import NavigationControls from "Common/NavigationControls";
import { useThemeContext } from "Theme/Context";
import { Surface, SurfaceHeader, SurfaceSection } from "Theme/Surface";

const focusOnErrors = createDecorator();

const CreateAccountPage = () => {
  const { intuit, cobalt } = useThemeContext();
  const history = useHistory();
  const { data: companyApplication, isLoading } = useGetCurrentCompanyApplicationQuery();
  const [createFromDarkAccount] = useCreateFromDarkAccountMutation();

  const submitHandler = async (values) => {
    // DEPRECATED TRACKING
    AnalyticsTracking.trackEvent("step_form_next_clicked", {
      name: "employerApplicationForm",
      page: 2,
    });

    // New Tracking
    AnalyticsTracking.trackEvent("button_clicked", {
      text: "Save and Continue",
      location: "Create Account Page",
    });

    try {
      await createFromDarkAccount({ ...values }).unwrap();

      history.push(addEmployeesURL);
    } catch (error) {
      return rtkQueryReponseToSubmissionError({ error });
    }
  };

  const handleClickBack = () => {
    // DEPRECATED TRACKING
    AnalyticsTracking.trackEvent("step_form_previous_clicked", {
      name: "employerApplicationForm",
      page: 2,
    });

    // New Tracking
    AnalyticsTracking.trackEvent("button_clicked", {
      text: "Back",
      location: "Create Account Page",
    });

    history.push(companyInformationURL);
  };

  let initialValues;
  if (!isLoading) {
    initialValues = { account: { email: companyApplication.email } };
  }

  // keepDirtyOnReinitialize is needed because the mutation will cause a state change, which causes a re-render.  When re-rendering, it'll
  // use stale companyApplication to generate initial values.  This results in the form visually "resetting" during the update, even though
  // the value is changed correctly.
  return (
    <Surface>
      {cobalt && !intuit && <SurfaceHeader>Enter Information</SurfaceHeader>}
      <SurfaceSection>
        <AgentHeader>Creating an account will allow you to return to your application later if you need to.</AgentHeader>
      </SurfaceSection>
      {isLoading ? (
        <BasicLoading />
      ) : (
        <Form onSubmit={submitHandler} decorators={[focusOnErrors]} initialValues={initialValues} keepDirtyOnReinitialize>
          {({ handleSubmit, submitting }) => (
            <form onSubmit={handleSubmit}>
              {/* TODO - remove SurfaceHeader in favor of section title prop when Cobalt launches */}
              {(!cobalt || (intuit && isIntuit())) && <SurfaceHeader>Account Creation</SurfaceHeader>}

              <SurfaceSection title="Account Creation">
                <Row>
                  <AccountEmail sm={5} />
                </Row>
                <Row>
                  <AccountPassword sm={5} />
                </Row>
              </SurfaceSection>
              <NavigationControls onClickBack={handleClickBack} submitting={submitting} />
            </form>
          )}
        </Form>
      )}
    </Surface>
  );
};

export default CreateAccountPage;
